import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from "react";
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }
    render() {
        if (this.state.hasError) {
            return (_jsx("div", { className: "min-h-screen bg-duvi-bg flex items-center justify-center p-6", children: _jsxs("div", { className: "w-full max-w-[480px] bg-duvi-surface border border-duvi-border rounded-[8px] p-8 text-center", children: [_jsx("div", { className: "text-duvi-destructive mb-4", style: {
                                fontSize: "var(--text-lg)",
                                fontWeight: "var(--font-weight-semibold)",
                            }, children: "Something went wrong" }), _jsx("p", { className: "text-duvi-text-secondary mb-6", style: { fontSize: "var(--text-sm)" }, children: this.state.error?.message ?? "An unexpected error occurred." }), _jsx("button", { onClick: () => window.location.reload(), className: "px-4 py-2 bg-duvi-accent text-white rounded-[6px] hover:bg-duvi-accent-hover transition-colors", style: { fontSize: "var(--text-sm)" }, children: "Reload page" })] }) }));
        }
        return this.props.children;
    }
}
//# sourceMappingURL=ErrorBoundary.js.map